module.exports = __webpack_public_path__ + "img/e-com-solution-logo.32b45526.png";